// SPDX-License-Identifier: AGPL-3.0-or-later

import {getConnectionProfileUrl} from '@app/features/connection/utils/ConnectionProviders';
import type {StreamActivity} from '@app/features/gateway/types/GatewayPresenceTypes';

const STREAM_LOGIN = /^[A-Za-z0-9_-]{1,64}$/;

// The address is never taken from the wire: a plain handle goes through the connection profile address.
export function getStreamActivityUrl(activity: StreamActivity): string | null {
	if (!STREAM_LOGIN.test(activity.login)) return null;
	return getConnectionProfileUrl({type: activity.platform, id: '', name: activity.login});
}
